import React, {useState} from 'react';
//material
import {
  Card,
  CardContent,
  withStyles,
  Collapse,
  IconButton,
  Grid,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Button
} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import {Skeleton} from '@material-ui/lab';
//utils
import Moment from 'moment';
//styles
import styles from './events-styles';

let scoreboardUrl = process.env.REACT_APP_COMPETITIONGOLF_SCOREBOARD_URL;
scoreboardUrl = (!scoreboardUrl.startsWith('#{') && !scoreboardUrl.endsWith('}#')) ? scoreboardUrl : 'https://scoreboard.competitiongolf.com/';

let bookingUrl = process.env.REACT_APP_COMPETITIONGOLF_TEMP_BOOKING_URL;
bookingUrl = (!bookingUrl.startsWith('#{') && !bookingUrl.endsWith('}#')) ? bookingUrl : null;

const EventsView = (props) => {
  const {classes, isLoading, events, pastEvents} = props;
  const [expanded, setExpanded] = useState(false);
  const [showPast, setShowPast] = useState(false);

  const displayEvents = showPast ? pastEvents : events;
  return (
    <Card>
      <CardContent className={classes.cardContent}>
        {
          isLoading ?
            <Skeleton height={40} width={'60%'} /> :
            <div className={classes.title}>
              Meetings
            </div>
        }

        <IconButton
          className={classes.expandButton + ' ' + (expanded ? classes.expandOpen : '')}
          onClick={() => setExpanded(!expanded)}
          size={'small'}>
          <ExpandMore />
        </IconButton>

        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <Grid container className={classes.gridContainer}>
            {
              !isLoading &&
                <Grid item xs={12} className={classes.buttonContainer}>
                  <Button color={'primary'} variant={showPast ? 'outlined' : 'contained'} onClick={() => setShowPast(false)} classes={{root: classes.viewButton}}>Upcoming</Button>
                  <Button color={'primary'} variant={!showPast ? 'outlined' : 'contained'} onClick={() => setShowPast(true)} classes={{root: classes.viewButton}}>Past</Button>
                </Grid>
            }

            {
              !isLoading && displayEvents.length > 0 &&
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Club</TableCell>
                    <TableCell className={classes.cellContent}>Players</TableCell>
                    <TableCell className={classes.cellContent}>Visitors</TableCell>
                    {showPast && <TableCell className={classes.cellContent}>Winner</TableCell>}
                    <TableCell className={classes.cellContent}>Scoreboard</TableCell>
                    {!showPast && <TableCell />}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {
                    displayEvents.map((e, i) => (
                      <TableRow key={i}>
                        <TableCell>{e.date ? Moment(new Date(e.date)).format('ddd Do MMM YYYY') : ''}</TableCell>
                        <TableCell>{e.club}</TableCell>
                        <TableCell className={classes.cellContent}>{e.players}</TableCell>
                        <TableCell className={classes.cellContent}>{e.visitors}</TableCell>
                        {showPast && <TableCell className={classes.cellContent}>{e.winner ? e.winner : '-'}</TableCell>}
                        <TableCell className={classes.cellContent}><a href={scoreboardUrl + '#!/code/' + e.eventCode} target={'_blank'} rel={'noopener'}>view</a></TableCell>
                        {!showPast && <TableCell>{e.canBook ? <a href={bookingUrl} target={'_blank'} rel={'noopener'}>book</a> : ''}</TableCell>}
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            }

            {
              !isLoading && displayEvents.length === 0 &&
                <div className={classes.defaultText}>
                  No Events to show
                </div>
            }
          </Grid>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (EventsView);
